import { Button } from "components/Button";
import { PlayerParticleHtml } from "components/PlayerParticleHtml";
import type { ThemeProps as Props } from "models/styles/theme";
import styled from "styled-components/macro";
import { calculateRems } from "styles/mixins/calculateRem";

export const StyledSubjectCard = styled.div<Props>`
  display: grid;
  column-gap: 3rem;
  grid-template-columns: 1fr auto;
  align-items: center;
  margin-bottom: 12px;
  border-radius: 16px;
  min-height: 7rem;
  border: 1px solid ${(props: Props) => props.theme.palette.neutral._900};
  background: ${(props: Props) => props.theme.palette.neutral.white};
  padding: ${calculateRems([20, 24, 20, 32])};
`;

export const StyledButton = styled(Button)`
  width: 9rem;
`;

export const StyledDescription = styled(PlayerParticleHtml)<Props>`
  * {
    font-size: ${(props: Props) => props.theme.font.size._14};
    color: ${(props: Props) => props.theme.palette.neutral.black};
  }

  :last-child {
    margin-bottom: 0 !important;
  }
`;
